import React from "react";
import Breadcrumbs from "../../Breadcrumbs/Breadcrumbs.js";
import Accordion from "../../Accordion/Accordion.js";
import useSEO from "../../hooks/useSEO.js";
import seoConfig from "../../hooks/seoConfig.js";

import data from "../../Data/specializedMedical/specializedMedicalData.json";

export default function SpecializedMedical() {
  useSEO(seoConfig.specializedMedical);

  return (
    <section className="contacts education">
      <Breadcrumbs />
      <h1 className="contacts__title history__title licenses__title">
        Специализированная медицинская помощь
      </h1>

      <Accordion data={data} />
    </section>
  );
}
